// SLIM Cart Interceptor - Visor:n mallin mukaan
console.log("🚀 SLIM Cart Interceptor loading...");

document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ SLIM Cart Interceptor loaded");

  // Odota että SLIM latautuu
  setTimeout(initializeInterceptor, 1000);
});

function initializeInterceptor() {
  console.log("🔄 Initializing interceptor...");

  // Etsi cart/add form useammalla tavalla
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  const productForms = document.querySelectorAll(".product-form");
  const allForms = document.querySelectorAll("form");

  console.log("🔍 All forms found:", allForms.length);
  console.log("🔍 Product forms found:", productForms.length);

  // Debug: listaa kaikki formit
  allForms.forEach((form, i) => {
    console.log(`Form ${i}:`, form.action, form.className);
  });

  const submitButtons = document.querySelectorAll(
    'button[name="add"][type="submit"]'
  );
  console.log("📋 Found cart forms:", forms.length);
  console.log("📋 Found submit buttons:", submitButtons.length);

  forms.forEach((form, index) => {
    console.log(`🔍 Processing form ${index + 1}:`, form);

    form.addEventListener("submit", function (event) {
      console.log("🛑 Cart form submit intercepted");

      // Tarkista onko SLIM-konfigurattorin aktiivinen
      const slimPrice = document.getElementById("slim-calculated-price");

      if (slimPrice && slimPrice.value && parseFloat(slimPrice.value) > 0) {
        console.log("💰 SLIM price found:", slimPrice.value);

        // Pysäytä normaali submit
        event.preventDefault();

        // Käsittele SLIM:n cart add
        handleSlimCartAdd(form, event);
      } else {
        console.log("➡️ No SLIM price, normal submit continues");
        // Anna normaalin submitin jatkua
      }
    });
  });

  // Jos ei löydy, yritä uudelleen
  if (forms.length === 0) {
    console.log("⏳ No forms found, retrying in 2 seconds...");
    setTimeout(initializeInterceptor, 2000);
    return;
  }
}

function handleSlimCartAdd(form, event) {
  console.log("🔧 Handling SLIM cart add...");

  try {
    // Hae form data
    const formData = new FormData(form);
    const variantId = formData.get("id");
    const quantity = parseInt(formData.get("quantity") || "1");

    // Hae SLIM:n laskettu hinta
    const calculatedPrice = parseFloat(
      document.getElementById("slim-calculated-price").value
    );

    // Hae SLIM:n properties
    const width = document.getElementById("width-input")?.value || "";
    const height = document.getElementById("height-input")?.value || "";
    const profileColor =
      document.getElementById("profile-hidden-input")?.value || "";

    console.log("📊 SLIM Cart Data:", {
      variantId,
      quantity,
      calculatedPrice,
      width,
      height,
      profileColor,
    });

    // Lisää SLIM:n properties
    formData.set("properties[_base_price]", calculatedPrice.toFixed(2));
    formData.set("properties[Leveys]", width);
    formData.set("properties[Korkeus]", height);
    formData.set("properties[Profiiliväri]", profileColor);

    console.log("📤 Submitting modified cart...");

    // Lähetä muokattu cart add
    submitModifiedCart(formData);
  } catch (error) {
    console.error("❌ SLIM Cart Add error:", error);
    // Fallback: normaali submit
    alert("Virhe tuotteen lisäämisessä. Yritetään normaalia tapaa...");
    form.submit();
  }
}

function submitModifiedCart(formData) {
  // Näytä loading
  showLoading();

  // Lähetä AJAX:lla
  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      console.log("📡 Cart response status:", response.status);
      return response.json();
    })
    .then((data) => {
      console.log("✅ Cart add success:", data);
      hideLoading();

      // Näytä success ja ohjaa ostoskoriin
      showSuccess();

      // Päivitä cart UI jos tarvitaan
      updateCartUI();
    })
    .catch((error) => {
      console.error("❌ Cart add failed:", error);
      hideLoading();
      alert("Tuotteen lisääminen ostoskoriin epäonnistui. Yritä uudelleen.");
    });
}

function showLoading() {
  console.log("⏳ Showing loading...");
  // Voit lisätä loading spinner tähän
}

function hideLoading() {
  console.log("✅ Hiding loading...");
  // Piilota loading spinner
}

function showSuccess() {
  console.log("🎉 Showing success...");
  // Voit lisätä success notification
  // Tai ohjata ostoskoriin
  window.location.href = "/cart";
}

function updateCartUI() {
  console.log("🔄 Updating cart UI...");
  // Trigger Shopify:n cart update jos tarvitaan
}

console.log("📝 SLIM Cart Interceptor script loaded");
